import {
  PaymentIdName
} from "./chunk-4ZUNUZGH.js";
import {
  createCustomClient,
  getBaseContractFromChainId,
  getChainFromId,
  isEthChain,
  isV2Tld,
  tldNamehash,
  validateName
} from "./chunk-ZJHIDWJ5.js";
import "./chunk-YUG22S6W.js";

// src/tlds/web3name/index.ts
import { createPublicClient as createPublicClient3, http as http3, namehash as namehash2 } from "viem";
import { normalize } from "viem/ens";

// src/utils/contract.ts
import {
  createPublicClient,
  getContract,
  toFunctionSelector,
  hexToBigInt,
  hexToNumber,
  http,
  keccak256
} from "viem";
import { bscTestnet, mainnet } from "viem/chains";

// src/abi/Resolver.ts
var ResolverAbi = [
  {
    inputs: [{ internalType: "bytes32", name: "node", type: "bytes32" }],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "uint256", name: "identifier", type: "uint256" }
    ],
    name: "tldName",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "string", name: "key", type: "string" }
    ],
    name: "text",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "uint256", name: "contentTypes", type: "uint256" }
    ],
    name: "ABI",
    outputs: [
      { internalType: "uint256", name: "", type: "uint256" },
      { internalType: "bytes", name: "", type: "bytes" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes32", name: "node", type: "bytes32" }],
    name: "addr",
    outputs: [{ internalType: "address payable", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "uint256", name: "coinType", type: "uint256" }
    ],
    name: "addr",
    outputs: [{ internalType: "bytes", name: "", type: "bytes" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes32", name: "node", type: "bytes32" }],
    name: "contenthash",
    outputs: [{ internalType: "bytes", name: "", type: "bytes" }],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/ReverseResolver.ts
var ReverseResolverAbi = [
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/SANN.ts
var SANNContractAbi = [
  {
    inputs: [{ internalType: "uint256", name: "identifier", type: "uint256" }],
    name: "tldBase",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/SIDRegistry.ts
var SIDRegistryAbi = [
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "resolver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/TldBase.ts
var TldBaseContractAbi = [
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/VerifiedTldHub.ts
var VerifiedTldHubAbi = [
  {
    inputs: [{ internalType: "uint256", name: "chainId", type: "uint256" }],
    name: "getChainInfo",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "chainId", type: "uint256" },
          { internalType: "string", name: "defaultRpc", type: "string" },
          { internalType: "address", name: "registry", type: "address" },
          { internalType: "address", name: "sann", type: "address" }
        ],
        internalType: "struct VerifiedTldHub.chainInfo",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "chainId", type: "uint256" }],
    name: "getChainTlds",
    outputs: [{ internalType: "string[]", name: "", type: "string[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "string[]", name: "tlds", type: "string[]" }],
    name: "getTldInfo",
    outputs: [
      {
        components: [
          { internalType: "string", name: "tld", type: "string" },
          { internalType: "uint256", name: "identifier", type: "uint256" },
          { internalType: "uint256", name: "chainId", type: "uint256" },
          { internalType: "string", name: "defaultRpc", type: "string" },
          { internalType: "address", name: "registry", type: "address" },
          { internalType: "address", name: "sann", type: "address" }
        ],
        internalType: "struct VerifiedTldHub.completeTldInfo[]",
        name: "",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getTlds",
    outputs: [{ internalType: "string[]", name: "", type: "string[]" }],
    stateMutability: "view",
    type: "function"
  }
];

// src/constants/contracts.ts
var CONTRACTS = {
  verifiedTldHub: "0x754D6827A57334143eD5fB58C5b1A4aAe4396ba5",
  verifiedTldHubTest: "0x123c784946a9b649FB1268D589E41bc7BF658725"
};

// src/utils/contract.ts
var ContractReader = class {
  constructor(isDev, rpcUrl, timeout) {
    this.isDev = isDev;
    this.rpcUrl = rpcUrl || "https://rpc.ankr.com/eth/01048c161385f5499bbe8f88cf68ce3d713c908be21217de37266424d49fefd7";
    if (!rpcUrl) {
      this.initRpcUrl().then((url) => {
        this.rpcUrl = url;
        console.log("Updated RPC URL:", this.rpcUrl);
      });
    }
    this.timeout = timeout;
  }
  async initRpcUrl() {
    try {
      const response = await fetch("https://spaceapi.prd.space.id/rpc/1");
      const data = await response.json();
      return data.url ?? "https://rpc.ankr.com/eth/01048c161385f5499bbe8f88cf68ce3d713c908be21217de37266424d49fefd7";
    } catch (error) {
      console.error("Error fetching RPC URL:", error);
      return "https://rpc.ankr.com/eth/01048c161385f5499bbe8f88cf68ce3d713c908be21217de37266424d49fefd7";
    }
  }
  getTimeout() {
    return this.timeout;
  }
  async withTimeout(operation, timeoutMs) {
    const effectiveTimeout = timeoutMs !== void 0 ? timeoutMs : this.timeout;
    if (!effectiveTimeout) {
      return operation(new AbortController().signal);
    }
    const controller = new AbortController();
    try {
      return await Promise.race([
        operation(controller.signal),
        new Promise((_, reject) => {
          setTimeout(() => {
            controller.abort();
            reject(new Error(`Operation timed out after ${effectiveTimeout}ms`));
          }, effectiveTimeout);
        })
      ]);
    } finally {
      if (!controller.signal.aborted) {
        controller.abort();
      }
    }
  }
  /** Get verified TLD hub contract */
  getVerifiedTldHubContract(timeout, signal) {
    const ethClient = createPublicClient({
      chain: this.isDev ? bscTestnet : mainnet,
      transport: http(this.isDev ? void 0 : this.rpcUrl, {
        timeout,
        fetchOptions: { signal }
      })
    });
    const hubContract = getContract({
      address: this.isDev ? CONTRACTS.verifiedTldHubTest : CONTRACTS.verifiedTldHub,
      abi: VerifiedTldHubAbi,
      client: {
        public: ethClient
      }
    });
    return hubContract;
  }
  async getTldInfo(tldList, timeout, signal) {
    const hubContract = this.getVerifiedTldHubContract(timeout, signal);
    const tldInfoList = await hubContract.read.getTldInfo([tldList]);
    return tldInfoList.filter((e) => !!e.tld);
  }
  /** Get resolver contract by TLD */
  async getResolverContractByTld(namehash3, tldInfo, rpcUrl, timeout, signal) {
    const client = createCustomClient(tldInfo, rpcUrl, timeout, signal);
    const registryContract = getContract({
      address: tldInfo.registry,
      abi: SIDRegistryAbi,
      client: {
        public: client
      }
    });
    const resolverAddr = await registryContract.read.resolver([namehash3]);
    if (!hexToNumber(resolverAddr)) {
      throw "resolver address is null";
    }
    const resolverContract = getContract({
      address: resolverAddr,
      abi: ResolverAbi,
      client: {
        public: client
      }
    });
    return resolverContract;
  }
  /** Get reverse resolver contract (V2 only) */
  async getReverseResolverContract(reverseNamehash, tldInfo, rpcUrl, timeout, signal) {
    if (!tldInfo.defaultRpc)
      return void 0;
    const client = createCustomClient(tldInfo, rpcUrl, timeout, signal);
    const registryContract = getContract({
      address: tldInfo.registry,
      abi: SIDRegistryAbi,
      client: {
        public: client
      }
    });
    const resolverAddr = await registryContract.read.resolver([reverseNamehash]);
    const resolverContract = getContract({
      address: resolverAddr ?? "",
      abi: ReverseResolverAbi,
      client: {
        public: client
      }
    });
    return resolverContract;
  }
  async getTldMetadata(domain, tldInfo, rpcUrl, timeout, signal) {
    const tokenId = hexToBigInt(keccak256(Buffer.from(domain.split(".")[0])));
    const client = createCustomClient(tldInfo, rpcUrl, timeout, signal);
    const sannContract = getContract({
      address: tldInfo.sann,
      abi: SANNContractAbi,
      client: {
        public: client
      }
    });
    const tldBaseContractAddr = tldInfo.identifier === BigInt(0) ? getBaseContractFromChainId(Number(tldInfo.chainId)) : await sannContract.read.tldBase([BigInt(`${tldInfo.identifier}`)]);
    if (tldInfo.chainId === BigInt(mainnet.id)) {
      return `https://metadata.ens.domains/mainnet/${tldBaseContractAddr}/${tokenId}`;
    }
    const tldBaseContract = getContract({
      address: tldBaseContractAddr,
      abi: TldBaseContractAbi,
      client: {
        public: client
      }
    });
    const metadata = await tldBaseContract.read.tokenURI([tokenId]);
    return metadata;
  }
  // Read content hash from resolver contract
  async getContenthash(namehash3, tldInfo, rpcUrl, timeout, signal) {
    const resolver = await this.getResolverContractByTld(namehash3, tldInfo, rpcUrl, timeout, signal);
    const functionExists = await this.resolverFunctionExists(
      resolver.address,
      "contenthash(bytes32)",
      tldInfo,
      rpcUrl,
      timeout,
      signal
    );
    if (!functionExists)
      return void 0;
    const contentHash = await resolver.read.contenthash([namehash3]);
    return contentHash;
  }
  // Read content hash from resolver contract
  async getABI(namehash3, tldInfo, rpcUrl, timeout, signal) {
    const resolver = await this.getResolverContractByTld(namehash3, tldInfo, rpcUrl, timeout, signal);
    const functionExists = await this.resolverFunctionExists(
      resolver.address,
      "ABI(bytes32, uint256)",
      tldInfo,
      rpcUrl,
      timeout,
      signal
    );
    if (!functionExists)
      return void 0;
    const contentHash = await resolver.read.ABI([namehash3, BigInt(1)]);
    return contentHash;
  }
  async containsTldNameFunction(resolverAddr, tldInfo, rpcUrl, timeout, signal) {
    const client = createCustomClient(tldInfo, rpcUrl, timeout, signal);
    const bytecode = await client.getBytecode({ address: resolverAddr });
    const selector = toFunctionSelector("tldName(bytes32, uint256)");
    return bytecode?.includes(selector.slice(2)) ?? false;
  }
  async resolverFunctionExists(resolverAddr, functionName, tldInfo, rpcUrl, timeout, signal) {
    const client = createCustomClient(tldInfo, rpcUrl, timeout, signal);
    const bytecode = await client.getBytecode({ address: resolverAddr });
    const selector = toFunctionSelector(functionName);
    return bytecode?.includes(selector.slice(2)) ?? false;
  }
};

// src/tlds/UD/index.ts
import { createPublicClient as createPublicClient2, getContract as getContract2, http as http2, namehash } from "viem";
import { polygon } from "viem/chains";

// src/abi/UD/ProxyReader.ts
var proxyReaderAbi = [
  {
    inputs: [
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getMany",
    outputs: [{ internalType: "string[]", name: "values", type: "string[]" }],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/UD/UNSRegistry.ts
var unsRegistryAbi = [
  {
    inputs: [{ internalType: "address", name: "addr", type: "address" }],
    name: "reverseNameOf",
    outputs: [{ internalType: "string", name: "reverseUri", type: "string" }],
    stateMutability: "view",
    type: "function"
  }
];

// src/tlds/UD/index.ts
var UDResolver = class {
  constructor() {
    this.proxyReaderAddress = "0x423F2531bd5d3C3D4EF7C318c2D1d9BEDE67c680";
    this.unsRegistryAddress = "0xa9a6A3626993D487d2Dbda3173cf58cA1a9D9e9f";
  }
  /**
   * Resolve address from name
   * @param domain
   * @returns
   */
  async getAddress(domain) {
    const client = createPublicClient2({
      chain: polygon,
      transport: http2()
    });
    const proxyReaderContract = getContract2({
      address: this.proxyReaderAddress,
      abi: proxyReaderAbi,
      client
    });
    const keys = ["crypto.ETH.address"];
    const res = await proxyReaderContract.read.getMany([keys, BigInt(namehash(domain))]);
    return res.at(0) || null;
  }
  /**
   * Resolve name from address
   * @param address
   * @returns
   */
  async getName(address) {
    const client = createPublicClient2({
      chain: polygon,
      transport: http2()
    });
    const registryContract = getContract2({
      address: this.unsRegistryAddress,
      abi: unsRegistryAbi,
      client
    });
    const res = await registryContract.read.reverseNameOf([address]);
    if (!res.endsWith(".crypto")) {
      return null;
    }
    return res;
  }
};

// src/tlds/lens/index.ts
var baseUrl = "https://api-v2.lens.dev/";
var LensProtocol = class {
  static async getDomainName(address) {
    const gql = `
  query defaultProfile($request: DefaultProfileRequest!) {
    defaultProfile(request: $request) {
      id
      handle{
        namespace
        localName
      }
    }
  }
`;
    const res = await fetch(baseUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        query: gql,
        variables: {
          request: {
            for: address
          }
        }
      })
    }).then((res2) => res2.json());
    return res.data.defaultProfile.handle.localName + "." + res.data.defaultProfile.handle.namespace;
  }
  static async getAddress(domain) {
    const gql = `
      query Profile($forHandle: Handle, $forProfileId: ProfileId) {
        profile(request: { forHandle: $forHandle, forProfileId: $forProfileId }) {
            id
            ownedBy {
              address
              chainId
            }
  }
}`;
    const newDomain = domain.split(".")[0];
    const res = await fetch(baseUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        query: gql,
        variables: {
          forHandle: `lens/${newDomain}`
        }
      })
    }).then((res2) => res2.json());
    return res.data.profile.ownedBy.address;
  }
};

// src/tlds/web3name/index.ts
var Web3Name = class {
  constructor({ isDev = false, rpcUrl, timeout } = {}) {
    this.resolverContractCache = /* @__PURE__ */ new Map();
    this.tldNameFunctionCache = /* @__PURE__ */ new Map();
    this.contractReader = new ContractReader(isDev, rpcUrl, timeout);
  }
  async getTldInfoList({
    queryTldList,
    queryChainIdList,
    rpcUrl,
    timeout,
    signal
  }) {
    const hubContract = this.contractReader.getVerifiedTldHubContract(timeout, signal);
    const chainTlds = [];
    for await (const chainId of queryChainIdList ?? []) {
      const tlds2 = await hubContract.read.getChainTlds([BigInt(chainId)]);
      if (isEthChain(chainId)) {
        const ethTld = tlds2.filter((e) => e !== "eth" /* ENS */).at(0);
        if (ethTld)
          chainTlds.push(ethTld);
        chainTlds.push("eth" /* ENS */);
      } else {
        const tldName = tlds2.at(0);
        if (tldName)
          chainTlds.push(tldName);
      }
    }
    const tlds = queryTldList ?? [];
    if (tlds.length === 0) {
      const allTlds = await hubContract.read.getTlds();
      tlds.push(...allTlds);
    }
    const reqTlds = queryChainIdList?.length ? chainTlds : tlds;
    return await this.contractReader.getTldInfo(reqTlds, timeout, signal);
  }
  async getResolverContract(tld, reverseNamehash, rpcUrl, timeout) {
    return tld.tld === "eth" /* ENS */ ? await this.contractReader.getReverseResolverContract(reverseNamehash, tld, rpcUrl, timeout) : await this.contractReader.getResolverContractByTld(reverseNamehash, tld, rpcUrl, timeout);
  }
  async isHasTldNameFunction(address, tld, reverseNamehash, rpcUrl, timeout) {
    let containsTldNameFunction;
    if (this.resolverContractCache.has(`${address}_${tld.tld}`)) {
      containsTldNameFunction = this.resolverContractCache.get(`${address}_${tld.tld}`);
    } else {
      containsTldNameFunction = await this.contractReader.containsTldNameFunction(address, tld, rpcUrl, timeout);
      this.resolverContractCache.set(`${address}_${tld.tld}`, containsTldNameFunction);
    }
    const res = {
      functionName: containsTldNameFunction ? "tldName" : "name",
      args: containsTldNameFunction ? [reverseNamehash, tld.identifier] : [reverseNamehash]
    };
    return res;
  }
  async getDomainNameByTld(address, reverseNamehash, tld, isTldName, rpcUrl, timeout) {
    let name = null;
    try {
      if (tld.tld === "eth" /* ENS */) {
        const contract = await this.contractReader.getReverseResolverContract(reverseNamehash, tld, rpcUrl, timeout);
        name = await contract?.read.name([reverseNamehash]) ?? "";
      } else {
        const contract = await this.contractReader.getResolverContractByTld(reverseNamehash, tld, rpcUrl, timeout);
        if (isTldName) {
          if (isV2Tld(tld.tld)) {
            const containsTldNameFunction = await this.contractReader.containsTldNameFunction(
              contract.address,
              tld,
              rpcUrl,
              timeout
            );
            if (containsTldNameFunction) {
              name = await contract.read.tldName([reverseNamehash, tld.identifier]);
            } else {
              name = await contract.read.name([reverseNamehash]);
            }
          } else {
            name = await contract.read.tldName([reverseNamehash, tld.identifier]);
          }
        } else {
          name = await contract.read.name([reverseNamehash]);
        }
      }
    } catch (error) {
    }
    if (name) {
      const reverseAddress = await this.getAddress(name, { rpcUrl, timeout });
      if (reverseAddress?.toLowerCase() === address.toLowerCase()) {
        return name;
      } else {
        return null;
      }
    }
    return name;
  }
  /**
   * Get domain name from address.
   * If queryChainIdList is specified, it will return domain name from that chain.
   * If queryTldList is specified, it will return domain name from that TLDs with the order.
   * If neither is specified, it will return domain name from all TLDs.
   * It's not recommended to use queryChainIdList and queryTldList together.
   *
   * @param {GetDomainNameProps} { address, queryChainIdList, queryTldList }
   * @return {*}  {(Promise<string | null>)}
   * @memberof Web3Name
   */
  async getDomainName({
    address,
    queryChainIdList,
    queryTldList,
    rpcUrl,
    timeout
  }) {
    return this.contractReader.withTimeout(async (signal) => {
      if (queryChainIdList?.length && queryTldList?.length) {
        console.warn("queryChainIdList and queryTldList cannot be used together, queryTldList will be ignored");
      }
      try {
        const reverseNode = `${normalize(address).slice(2)}.addr.reverse`;
        const reverseNamehash = namehash2(reverseNode);
        const tldInfoList = await this.getTldInfoList({
          queryChainIdList,
          queryTldList,
          rpcUrl,
          timeout,
          signal
        });
        const resList = [];
        for await (const tld of tldInfoList) {
          if (!tld.tld)
            continue;
          const isTldName = !!queryTldList?.length;
          let name = await this.getDomainNameByTld(address, reverseNamehash, tld, isTldName, rpcUrl, timeout);
          if (name) {
            resList.push(name);
            break;
          }
        }
        if (queryTldList?.includes("lens" /* LENS */)) {
          const lensName = await LensProtocol.getDomainName(address);
          if (lensName)
            resList.push(lensName);
        } else if (queryTldList?.includes("crypto" /* CRYPTO */)) {
          const UD = new UDResolver();
          const udName = await UD.getName(address);
          if (udName)
            resList.push(udName);
        }
        return resList.at(0) ?? null;
      } catch (e) {
        if (e instanceof Error && e.name === "AbortError") {
          throw new Error(`Request timed out after ${timeout || this.contractReader.getTimeout()}ms`);
        }
        console.log(`Error getting name for reverse record of ${address}`, e);
        return null;
      }
    }, timeout);
  }
  /**
   * Batch resolve a list of addresses to their corresponding domain names.
   * This method aggregates multiple resolver calls to improve efficiency.
   * It will return an array of objects containing the address and its resolved domain name.
   *
   * @param {Address[]} addressList - The list of addresses to resolve.
   * @param {TldInfo} tldInfo - The TLD information used for resolving.
   * @return {*}  {(Promise<BatchGetReturn | null>)} - A promise that resolves to an array of objects, each containing the address and its corresponding domain name, or null if an error occurs.
   * @memberof Web3Name
   */
  async batchResolve(addressList, tldInfo, isTldName, rpcUrl, timeout) {
    const client = createCustomClient(tldInfo, rpcUrl, timeout);
    try {
      const reverseAddress = addressList.map((address) => {
        const reverseNode = `${normalize(address).slice(2)}.addr.reverse`;
        const reverseNamehash = namehash2(reverseNode);
        return {
          reverseNamehash
        };
      });
      const resolverContractCalls = reverseAddress.map(({ reverseNamehash }) => {
        return {
          address: tldInfo.registry,
          abi: SIDRegistryAbi,
          functionName: "resolver",
          args: [reverseNamehash]
        };
      });
      const resolverContract = (await client.multicall({
        contracts: resolverContractCalls
      })).map((v, index) => {
        return {
          address: v.result,
          reverseNamehash: reverseAddress[index].reverseNamehash
        };
      });
      const tldNameFunctionResults = [];
      for (const { address, reverseNamehash } of resolverContract) {
        const cacheKey = `${address}_${reverseNamehash}_${isTldName}`;
        if (this.tldNameFunctionCache.has(cacheKey)) {
          tldNameFunctionResults.push({
            ...this.tldNameFunctionCache.get(cacheKey),
            reverseNamehash
          });
        } else {
          if (isTldName) {
            const data = await this.isHasTldNameFunction(address, tldInfo, reverseNamehash, rpcUrl, timeout);
            this.tldNameFunctionCache.set(cacheKey, data);
            tldNameFunctionResults.push({
              ...data,
              reverseNamehash
            });
          } else {
            const data = {
              functionName: "name",
              args: [reverseNamehash]
            };
            this.tldNameFunctionCache.set(cacheKey, data);
            tldNameFunctionResults.push({
              ...data,
              reverseNamehash
            });
          }
        }
      }
      const calls = resolverContract.map(({ address, reverseNamehash }) => {
        const { functionName, args } = tldNameFunctionResults.find((item) => item.reverseNamehash === reverseNamehash);
        return {
          address,
          abi: ResolverAbi,
          functionName,
          args
        };
      });
      const domainRes = (await client.multicall({
        contracts: calls
      })).map((v) => v.result);
      const res = [];
      const verifiedRes = await this.batchGetAddress({ nameList: domainRes, tldInfo });
      const verifiedAddress = verifiedRes?.map(({ address }) => address);
      addressList.forEach((address, index) => {
        if (address.toLowerCase() === verifiedAddress?.[index]?.toLowerCase()) {
          res.push({
            address,
            domain: domainRes[index]
          });
        } else {
          res.push({
            address,
            domain: null
          });
        }
      });
      return res ?? null;
    } catch (e) {
      console.log(`Error getting names for addresses`, e);
      return null;
    }
  }
  async batchGetDomainNameByTld({
    addressList,
    queryTld,
    rpcUrl,
    timeout
  }) {
    return this.contractReader.withTimeout(async (signal) => {
      if (!addressList?.length)
        return [];
      const tldInfoList = await this.getTldInfoList({ queryTldList: [queryTld] });
      const tldInfo = tldInfoList.find((tld) => tld.tld === queryTld);
      if (!tldInfo) {
        return null;
      }
      try {
        const res = await this.batchResolve(addressList, tldInfo, true, rpcUrl, timeout);
        return res;
      } catch (error) {
        console.log("error: ", error);
        return null;
      }
    }, timeout);
  }
  async batchGetDomainNameByChainId({
    addressList,
    queryChainId,
    rpcUrl,
    timeout
  }) {
    return this.contractReader.withTimeout(async (signal) => {
      if (!addressList?.length)
        return [];
      const tldInfoList = await this.getTldInfoList({ queryChainIdList: [queryChainId] });
      const tldInfo = tldInfoList.find((tld) => tld.chainId === BigInt(queryChainId));
      if (!tldInfo) {
        return null;
      }
      try {
        const res = await this.batchResolve(addressList, tldInfo, false, rpcUrl, timeout);
        return res;
      } catch (error) {
        console.log("error: ", error);
        return null;
      }
    }, timeout);
  }
  async batchGetAddress({
    nameList,
    tldInfo,
    rpcUrl,
    timeout
  }) {
    if (!nameList?.length)
      return [];
    const client = createCustomClient(tldInfo, rpcUrl, timeout);
    try {
      const verifiedNames = nameList.map((name) => {
        const normalizedDomain = "lens" /* LENS */ === tldInfo.tld ? name : normalize(name);
        const namehash3 = tldNamehash(normalizedDomain, isV2Tld(tldInfo.tld) ? void 0 : tldInfo.identifier);
        return namehash3;
      });
      const resolveContractCalls = verifiedNames.map((namehash3) => {
        return {
          address: tldInfo.registry,
          abi: SIDRegistryAbi,
          functionName: "resolver",
          args: [namehash3]
        };
      });
      const resolverContracts = (await client.multicall({
        contracts: resolveContractCalls
      })).map((v, index) => {
        return {
          address: v.result,
          namehash: verifiedNames[index]
        };
      });
      const getAddressCalls = resolverContracts.map(({ address, namehash: namehash3 }) => {
        return {
          address,
          abi: ResolverAbi,
          functionName: "addr",
          args: [namehash3]
        };
      });
      const res = (await client.multicall({
        contracts: getAddressCalls
      })).map((v, index) => {
        return {
          address: v.result ?? null,
          domain: nameList[index]
        };
      });
      return res;
    } catch (error) {
      console.log(`Error getting address for names`, error);
      return null;
    }
  }
  async batchGetDomainName({
    addressList,
    queryChainIdList,
    queryTldList,
    rpcUrl,
    timeout
  }) {
    return this.contractReader.withTimeout(async (signal) => {
      if (queryChainIdList?.length && queryTldList?.length) {
        console.warn("queryChainIdList and queryTldList cannot be used together, queryTldList will be ignored");
      }
      if (!addressList.length)
        return [];
      let curAddr = addressList[0];
      try {
        const tldInfoList = await this.getTldInfoList({ queryChainIdList, queryTldList, rpcUrl });
        const resList = [];
        const isIncludeLens = queryTldList?.includes("lens" /* LENS */);
        const isIncludeCrypto = queryTldList?.includes("crypto" /* CRYPTO */);
        for await (const address of addressList) {
          curAddr = address;
          const reverseNode = `${normalize(address).slice(2)}.addr.reverse`;
          const reverseNamehash = namehash2(reverseNode);
          let nameRes = null;
          for await (const tld of tldInfoList) {
            if (!tld.tld)
              continue;
            const isTldName = !!queryTldList?.length;
            nameRes = await this.getDomainNameByTld(address, reverseNamehash, tld, isTldName, rpcUrl, timeout);
            if (nameRes) {
              break;
            }
          }
          if (!nameRes && isIncludeLens) {
            nameRes = await LensProtocol.getDomainName(address);
          }
          if (!nameRes && isIncludeCrypto) {
            const UD = new UDResolver();
            nameRes = await UD.getName(address);
          }
          resList.push({ address, domain: nameRes });
        }
        return resList;
      } catch (e) {
        console.log(`Error getting name for reverse record of ${curAddr}`, e);
        return null;
      }
    }, timeout);
  }
  /**
   * Get address from name. If coinType is specified, it will return ENSIP-9 address for that coinType.
   *
   * @param {string} name
   * @param {{ coinType?: number; rpcUrl?: string; timeout?: number }} { coinType, rpcUrl, timeout }
   * @return {*}  {(Promise<string | null>)}
   * @memberof Web3Name
   */
  async getAddress(name, { coinType, rpcUrl, timeout } = {}) {
    return this.contractReader.withTimeout(async (signal) => {
      const tld = name.split(".").pop()?.toLowerCase();
      if (!tld) {
        return null;
      }
      const normalizedDomain = "lens" /* LENS */ === tld ? name : normalize(name);
      if (tld !== "eth" /* ENS */ && tld !== "lens" /* LENS */ && tld !== "crypto" /* CRYPTO */) {
        validateName(normalizedDomain);
      }
      try {
        if (tld === "eth" /* ENS */) {
          const data = await fetch("https://spaceapi.prd.space.id/rpc/1");
          const rpcUrlConfig = await data.json();
          const tldInfoList2 = await this.contractReader.getTldInfo([tld]);
          const publicClient = createPublicClient3({
            chain: getChainFromId(Number(tldInfoList2[0].chainId)),
            transport: http3(
              rpcUrl || "https://rpc.ankr.com/eth/01048c161385f5499bbe8f88cf68ce3d713c908be21217de37266424d49fefd7",
              {
                timeout,
                fetchOptions: { signal }
              }
            )
          });
          return await publicClient.getEnsAddress({
            name: normalizedDomain
          });
        }
        if (tld === "lens" /* LENS */) {
          return await LensProtocol.getAddress(name);
        }
        if (tld === "crypto" /* CRYPTO */) {
          const UD = new UDResolver();
          return await UD.getAddress(name);
        }
        const tldInfoList = await this.contractReader.getTldInfo([tld]);
        const tldInfo = tldInfoList.at(0);
        if (!tldInfo) {
          throw "TLD not found";
        }
        const namehash3 = tldNamehash(normalizedDomain, isV2Tld(tld) ? void 0 : tldInfo.identifier);
        const resolverContract = await this.contractReader.getResolverContractByTld(
          namehash3,
          tldInfo,
          rpcUrl,
          timeout,
          signal
        );
        const res = coinType !== void 0 ? await resolverContract.read.addr([namehash3, BigInt(coinType)]) : await resolverContract.read.addr([namehash3]);
        return res;
      } catch (error) {
        if (error instanceof Error && error.name === "AbortError") {
          throw new Error(`Request for ${name} timed out`);
        }
        console.error(`Error getting address for ${name}`, error);
        return null;
      }
    }, timeout);
  }
  /**
   * Get available domain list from address.
   *
   * @param {GetDomainNameProps} { address, queryChainIdList, queryTldList }
   * @return {*}  {Promise<string[]>}
   * @memberof Web3Name
   */
  async getDomainNames({
    address,
    queryChainIdList,
    queryTldList,
    rpcUrl,
    timeout
  }) {
    return this.contractReader.withTimeout(async (signal) => {
      if (queryChainIdList?.length && queryTldList?.length) {
        console.warn("queryChainIdList and queryTldList cannot be used together, queryTldList will be ignored");
      }
      const resList = /* @__PURE__ */ new Set([]);
      try {
        const reverseNode = `${address.toLowerCase().slice(2)}.addr.reverse`;
        const reverseNamehash = namehash2(reverseNode);
        const hubContract = this.contractReader.getVerifiedTldHubContract(timeout);
        const chainTlds = [];
        for (const chainId of queryChainIdList ?? []) {
          const tlds2 = await hubContract.read.getChainTlds([BigInt(chainId)]);
          if (isEthChain(chainId)) {
            const ethTld = tlds2.filter((e) => e !== "eth" /* ENS */).at(0);
            if (ethTld)
              chainTlds.push(ethTld);
            chainTlds.push("eth" /* ENS */);
          } else {
            const tldName = tlds2.at(0);
            if (tldName)
              chainTlds.push(tldName);
          }
        }
        const tlds = queryTldList ?? [];
        if (tlds.length === 0) {
          const allTlds = await hubContract.read.getTlds();
          tlds.push(...allTlds);
        }
        const reqTlds = queryChainIdList?.length ? chainTlds : tlds;
        const tldInfoList = await this.contractReader.getTldInfo(reqTlds);
        for (const tld of tldInfoList) {
          if (!tld.tld)
            continue;
          let name = "";
          try {
            if (tld.tld === "eth" /* ENS */) {
              const contract = await this.contractReader.getReverseResolverContract(reverseNamehash, tld, rpcUrl);
              name = await contract?.read.name([reverseNamehash]) ?? "";
            } else {
              const contract = await this.contractReader.getResolverContractByTld(reverseNamehash, tld, rpcUrl);
              if (queryTldList?.length) {
                if (isV2Tld(tld.tld)) {
                  const containsTldNameFunction = await this.contractReader.containsTldNameFunction(
                    contract.address,
                    tld,
                    rpcUrl
                  );
                  if (!containsTldNameFunction)
                    throw "TLD name is not supported for this TLD";
                }
                name = await contract.read.tldName([reverseNamehash, tld.identifier]);
              } else {
                name = await contract.read.name([reverseNamehash]);
              }
            }
          } catch (error) {
            continue;
          }
          if (name) {
            const reverseAddress = await this.getAddress(name, { rpcUrl });
            if (reverseAddress === address) {
              resList.add(name);
            }
          }
        }
        if (queryTldList?.includes("lens" /* LENS */)) {
          const lensName = await LensProtocol.getDomainName(address);
          if (lensName)
            resList.add(lensName);
        } else if (queryTldList?.includes("crypto" /* CRYPTO */)) {
          const UD = new UDResolver();
          const name = await UD.getName(address);
          name && resList.add(name);
        }
        return Array.from(resList);
      } catch (e) {
        console.log(`Error getting name for reverse record of ${address}`, e);
        return [];
      }
    }, timeout);
  }
  /**
   * Get domain record from name and key.
   *
   * @param {{ name: string; key: string; rpcUrl?: string; timeout?: number }} { name, key, rpcUrl, timeout }
   * @return {*}
   * @memberof Web3Name
   */
  async getDomainRecord({
    name,
    key,
    rpcUrl,
    timeout
  }) {
    return this.contractReader.withTimeout(async (signal) => {
      const tld = name.split(".").pop()?.toLowerCase();
      if (!tld) {
        return null;
      }
      try {
        const normalizedDomain = "lens" /* LENS */ === tld ? name : normalize(name);
        const tldInfoList = await this.contractReader.getTldInfo([tld]);
        const tldInfo = tldInfoList[0];
        if (!tldInfo) {
          throw "TLD not found";
        }
        const namehash3 = tldNamehash(normalizedDomain, isV2Tld(tld) ? void 0 : tldInfo.identifier);
        const resolverContract = await this.contractReader.getResolverContractByTld(namehash3, tldInfo, rpcUrl);
        const record = await resolverContract.read.text([namehash3, key]);
        return record;
      } catch (error) {
        console.error(`Error getting address for ${name}`, error);
        return null;
      }
    }, timeout);
  }
  /**
   * Get domain metadata from name.
   *
   * @param {{ name: string; rpcUrl?: string; timeout?: number }} { name, rpcUrl, timeout }
   * @return {*}
   * @memberof Web3Name
   */
  async getMetadata({ name, rpcUrl, timeout }) {
    return this.contractReader.withTimeout(async (signal) => {
      const tld = name.split(".").pop()?.toLowerCase();
      if (!tld) {
        return null;
      }
      try {
        const tldInfo = await this.contractReader.getTldInfo([tld]);
        if (!tldInfo || !tldInfo.at(0)?.sann) {
          return null;
        }
        const metadata = await this.contractReader.getTldMetadata(name, tldInfo[0], rpcUrl);
        const res = await fetch(metadata).then((res2) => res2.json());
        return res;
      } catch (error) {
        console.error(`Error getting metadata for ${name}`, error);
      }
    }, timeout);
  }
  /**
   * Get domain avatar from name.
   *
   * @param {{ name: string; rpcUrl?: string; timeout?: number }} { name, rpcUrl, timeout }
   * @return {*}
   * @memberof Web3Name
   */
  async getDomainAvatar({
    name,
    key,
    rpcUrl,
    timeout
  }) {
    return this.contractReader.withTimeout(async (signal) => {
      const metadata = await this.getMetadata({ name, rpcUrl, timeout });
      return metadata?.image;
    }, timeout);
  }
  /**
   * Get domain content hash from name.
   *
   * @param {{ name: string; rpcUrl?: string; timeout?: number }} { name, rpcUrl, timeout }
   * @return {*}  {(Promise<string | undefined>)}
   * @memberof Web3Name
   */
  async getContentHash({
    name,
    rpcUrl,
    timeout
  }) {
    return this.contractReader.withTimeout(async (signal) => {
      const tld = name.split(".").pop()?.toLowerCase();
      if (!tld) {
        return void 0;
      }
      try {
        const tldInfo = await this.contractReader.getTldInfo([tld]);
        if (!tldInfo)
          throw "TLD not found";
        const namehash3 = tldNamehash(normalize(name), isV2Tld(tld) ? void 0 : tldInfo[0].identifier);
        const contenthash = await this.contractReader.getContenthash(namehash3, tldInfo[0], rpcUrl);
        if (!contenthash || contenthash === "0x")
          return void 0;
        return contenthash;
      } catch (error) {
        console.error(`Error getting content hash for ${name}`, error);
      }
    }, timeout);
  }
  /**
   * Retrieves the ABI (Application Binary Interface) for a given name on the Web3Name system.
   * @param name - The name for which to retrieve the ABI.
   * @param rpcUrl - Optional RPC URL to use for retrieving the ABI.
   * @returns The ABI for the specified name, or undefined if the TLD (Top-Level Domain) is not found.
   */
  // async getABI({ name, rpcUrl, timeout }: { name: string; rpcUrl?: string; timeout?: number }) {
  //   const tld = name.split('.').pop()?.toLowerCase()
  //   if (!tld) {
  //     return undefined
  //   }
  //   try {
  //     const tldInfo = (await this.contractReader.getTldInfo([tld], timeout)).at(0)
  //     if (!tldInfo) throw 'TLD not found'
  //     const namehash = tldNamehash(normalize(name), isV2Tld(tld) ? undefined : tldInfo.identifier)
  //     const abi = await this.contractReader.getABI(namehash, tldInfo, rpcUrl, timeout)
  //     return abi
  //   } catch (error) {
  //     console.error(`Error getting content hash for ${name}`, error)
  //   }
  // }
};

// src/index.ts
function createWeb3Name({
  isDev = false,
  rpcUrl,
  timeout
} = {}) {
  return new Web3Name({ isDev, rpcUrl, timeout });
}
function createPaymentIdName() {
  return new PaymentIdName();
}
export {
  createPaymentIdName,
  createWeb3Name
};
